<template>
    <section class="uk-section">
    <div class="uk-container uk-container-expand">

        <div uk-filter="target: .js-filter">
            <div class="uk-grid-small uk-grid-divider uk-child-width-auto" uk-grid>

                <div>
                    <ul class="uk-subnav uk-subnav-pill" uk-margin>
                        <li class="uk-active" uk-filter-control><a href="#">All</a></li>
                    </ul>
                </div>
                

                <div>
                    <ul class="uk-subnav uk-subnav-pill" uk-margin>
                        <li>
                            <a href="#">Use<span uk-icon="icon:  triangle-down"></span></a>
                            <div uk-dropdown="mode: click;">
                                <ul class="uk-nav uk-dropdown-nav">
                                    <li uk-filter-control="filter: [data-use*='civic']; group: use"><a href="#">Civic</a></li>
                                    <li uk-filter-control="filter: [data-use*='commercial']; group: use"><a href="#">Commercial</a></li>
                                    <li uk-filter-control="filter: [data-use*='education']; group: use"><a href="#">Education</a></li>
                                    <li uk-filter-control="filter: [data-use*='healthcare']; group: use"><a href="#">Healthcare</a></li>
                                    <li uk-filter-control="filter: [data-use*='recreational']; group: use"><a href="#">Recreational</a></li>
                                    <li uk-filter-control="filter: [data-use*='religious']; group: use"><a href="#">Religious</a></li>
                                    <li uk-filter-control="filter: [data-use*='residential']; group: use"><a href="#">Residential</a></li>
                                </ul>
                            </div>
                        </li>

                        <li>
                            <a href="#">Type<span uk-icon="icon:  triangle-down"></span></a>
                            <div uk-dropdown="mode: click;">
                                <ul class="uk-nav uk-dropdown-nav">
                                    <li uk-filter-control="filter: [data-type*='new-construction']; group: type"><a href="#">New Construction</a></li>
                                    <li uk-filter-control="filter: [data-type*='renovation']; group: type"><a href="#">Addition/Renovation</a></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>

                <div>
                    <form action="/projects/search-results" method="GET">
                        <div>
                            <div class="uk-inline">
                                <span class="uk-form-icon" uk-icon="icon: search"></span>
                                <input class="uk-input uk-form-small" type="text" name="q">
                            </div>
                            <button class="uk-button uk-button-primary uk-button-small">Search</button>
                        </div>
                    </form>
                </div>

                <div class="uk-width-expand@m">
                    <ul class="uk-subnav uk-subnav-pill">
                        <li v-if="presentationMode === 'architecture'"><a @click="toggleMode" href="#">Show Interior Design</a></li>
                        <li v-else><a @click="toggleMode" href="#">Show Architecture</a></li>
                    </ul>
                </div>

            </div>
            <hr>

            <div v-if="loading" class="uk-text-center uk-padding-small">
                <div uk-spinner="ratio:2"></div>
                <p>Loading projects...</p>
            </div>

            <ul class="js-filter uk-child-width-1-2 uk-child-width-1-3@m uk-grid-small" uk-grid>
                <project-item v-for="project in projects" v-bind="project" :key="project.id" :presentationMode="presentationMode"></project-item>
            </ul>


        </div>
    
    </div><!-- end container -->
    </section><!-- end section -->
</template>

<script>
import axios from 'axios'
import ProjectItem from './ProjectItem.vue'


export default {
    data() {
        return {
            loading: true,
            presentationMode: "architecture",
            projects: [],
            errors: []
        }
    },
    created() {
        axios.get()
        .then(response => {
            this.loading = false
        this.projects = response.data
        })
        .catch(e => {
        this.errors.push(e)
        })
    },
    methods: {
        toggleMode() {
            if (this.presentationMode === 'architecture') {
                this.presentationMode = 'interior-design';
            } else {
                this.presentationMode = 'architecture';
            }
        },

    },
    components: {
        ProjectItem,
    },
}
</script>




// WEBPACK FOOTER //
// src/components/ProjectList.vue